/*jshint esversion: 11 */
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Badge, Spinner, Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import { getLoginHistory } from '../../api/sessions';

const LoginHistoryTab = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20, total_pages: 0 });
  const [userType, setUserType] = useState('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetchHistory = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const res = await getLoginHistory({
        user_type: userType === 'all' ? undefined : userType,
        from_date: fromDate || undefined,
        to_date: toDate || undefined,
        page,
        limit: 20
      });
      setRecords(res.data.records || []);
      setPagination(res.data.pagination || {});
    } catch {
      toast.error('Failed to load login history');
    } finally {
      setLoading(false);
    }
  }, [userType, fromDate, toDate]);

  useEffect(() => { fetchHistory(1); }, [fetchHistory]);

  const parseUserAgent = (ua = '') => {
    if (!ua) return '-';
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Safari')) return 'Safari';
    if (ua.includes('Edge')) return 'Edge';
    return ua.slice(0, 30);
  };

  return (
    <>
      <Row className="mb-3">
        <Col md={3}>
          <FormGroup>
            <Label className="mb-1">User Type</Label>
            <Input type="select" value={userType} onChange={(e) => setUserType(e.target.value)}>
              <option value="all">All</option>
              <option value="super_admin">Super Admin</option>
              <option value="staff">Staff</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="mb-1">From</Label>
            <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="mb-1">To</Label>
            <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={3} className="d-flex align-items-end">
          <Button color="light" onClick={() => { setUserType('all'); setFromDate(''); setToDate(''); }}>
            Clear
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="text-center py-4"><Spinner color="primary" /></div>
      ) : records.length === 0 ? (
        <p className="text-muted text-center py-4">No login history found.</p>
      ) : (
        <>
          <div className="table-responsive">
            <Table className="table-centered table-nowrap mb-0">
              <thead className="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Role</th>
                  <th>Login Time</th>
                  <th>IP Address</th>
                  <th>Device</th>
                </tr>
              </thead>
              <tbody>
                {records.map((r) => (
                  <tr key={r._id}>
                    <td>{r.name}</td>
                    <td>{r.phone_number}</td>
                    <td>
                      <Badge color={r.user_type === 'super_admin' ? 'danger' : 'primary'} pill>
                        {r.user_type === 'super_admin' ? 'Super Admin' : 'Staff'}
                      </Badge>
                    </td>
                    <td>{moment(r.createdAt).format('DD MMM YYYY, hh:mm A')}</td>
                    <td>{r.ip_address || '-'}</td>
                    <td>{parseUserAgent(r.user_agent)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <span className="text-muted">
              {pagination.total} total record{pagination.total !== 1 ? 's' : ''}
            </span>
            <div>
              <Button size="sm" color="light" disabled={pagination.page <= 1} onClick={() => fetchHistory(pagination.page - 1)} className="mr-2">Prev</Button>
              <span className="mx-2">Page {pagination.page} of {pagination.total_pages}</span>
              <Button size="sm" color="light" disabled={pagination.page >= pagination.total_pages} onClick={() => fetchHistory(pagination.page + 1)}>Next</Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LoginHistoryTab;
